export default {
	index: "/",

	auth: {
		login: "/auth/login",
		logout: "/auth/logout",
	},

	admin: {
		index: "/admin",
		login: "/admin/login",
		profile: "/admin/profile",
		analytics: {
			index: "/admin/analytics",
		},
		shows: {
			index: "/admin/shows",
			create: "/admin/shows/create",
			edit: "/admin/shows/:id",
		},
		notifications: {
			index: "/admin/notifications",
		},
		categories: {
			index: "/admin/categories",
			create: "/admin/categories/create",
			edit: "/admin/categories/:id",
		},
		users: {
			index: "/admin/users",
			edit: "/admin/users/:id",
		},
		devices: {
			index: "/admin/devices",
		},
		stores: {
			index: "/admin/stores",
			edit: "/admin/stores/:id",
		},
		tokens: {
			index: "/admin/tokens",
			edit: "/admin/tokens/:id",
		},
		admins: {
			index: "/admin/admins",
			create: "/admin/admins/create",
			edit: "/admin/admins/:id",
		},
		messages: {
			index: "/admin/messages",
			create: "/admin/messages/create",
			edit: "/admin/messages/:id",
		},
		products: {
			index: "/admin/products",
			create: "/admin/products/create",
			edit: "/admin/products/:id",
		},
		orders: {
			index: "/admin/orders",
			create: "/admin/orders/create",
			edit: "/admin/orders/:id",
		},
		bids: {
			index: "/admin/bids",
			create: "/admin/bids/create",
			edit: "/admin/bids/:id",
		},
		payouts: {
			index: "/admin/payouts",
			create: "/admin/payouts/create",
			edit: "/admin/payouts/:id",
		},
		referralCampaigns: {
			index: "/admin/referral-campaigns",
			create: "/admin/referral-campaigns/create",
			edit: "/admin/referral-campaigns/:id",
		},
	},
} as const;
